import React from 'react';

const CopyLink = (props: object) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5871 2.50455C12.6791 0.412544 16.0708 0.412547 18.1628 2.50455C20.2548 4.59656 20.2548 7.98838 18.1628 10.0804L15.0378 13.2053L13.7121 11.8796L16.8371 8.75455C18.1968 7.39478 18.1968 5.19015 16.8371 3.83038C15.4773 2.4706 13.2727 2.4706 11.9129 3.83038L8.7879 6.95538L7.46207 5.62955L10.5871 2.50455ZM14.4128 7.58038L6.9129 15.0803L5.58707 13.7546L13.0871 6.25455L14.4128 7.58038ZM1.83707 18.8303C3.92908 20.9223 7.32088 20.9225 9.4129 18.8303L12.5378 15.7053L11.2121 14.3796L8.08707 17.5046C6.72729 18.8643 4.52267 18.8643 3.1629 17.5046C1.80312 16.1448 1.80312 13.9402 3.1629 12.5804L6.2879 9.45538L4.96207 8.12955L1.83707 11.2546C-0.254934 13.3466 -0.254936 16.7383 1.83707 18.8303Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyLink;
